import React from "react";
import Dialog from "../../../../shared/dialog";
import MyButton from "../../../../shared/buttons/primary";
import "./index.scss";
import FormSelect from "../../../../shared/form-select";
import { BOOKING_TABLE_TIMES_OPTIONS } from "../../../../../constants/app";

const ConfirmModal = (props) => {
  const state = window.store.getState();
  const user = state.auth.user;
  const [stayDuration, setStayDuration] = React.useState(user?.stay_duration);
  const [isCustomStayDuration, setIsCustomStayDuration] = React.useState(false);
  const { onClose, onAccept, modalData, time } = props;

  const handleChangeCustomStayDuration = (e) => {
    const { checked } = e.target;
    setIsCustomStayDuration(checked);
  };

  return (
    <Dialog
      id="confirm-dialog"
      className={"confirm-dialog booking-dialog"}
      isShow={true}
      onCloseRequest={onClose}
      closeOnOverlayClick={true}
    >
      <div className="booking-form">
        <div className="booking-form__row align-items-start">
          <div className="booking-form__label ">
            <label className="form-label user-select-none">選択テーブル</label>
          </div>
          <div className="booking-form__control">
            <div className="booking-form__input-value">
              {modalData?.map((item) => {
                const value = `${item.table?.name} - ${item.seat_name}`;
                return (
                  <div className="mb-2" key={item.id}>
                    {value}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="booking-form__row pt-3">
          <div className="booking-form__label">
            <label className="form-label user-select-none">開始時間</label>
          </div>
          <div className="booking-form__control">
            <span className="booking-form__input-value">{time}</span>
          </div>
        </div>

        {isCustomStayDuration ? (
          <FormSelect
            className="mt-3 w-50"
            onChange={(value) => {
              setStayDuration(value);
            }}
            valueSelected={stayDuration || 30}
            options={BOOKING_TABLE_TIMES_OPTIONS}
            label="滞在時間"
          />
        ) : (
          <div className="booking-form__row pt-3">
            <div className="booking-form__label">
              <label className="form-label user-select-none">滞在時間</label>
            </div>
            <div className="booking-form__control">
              <span className="booking-form__input-value">
                {
                  BOOKING_TABLE_TIMES_OPTIONS.find(
                    (item) => item.value === user?.stay_duration
                  ).label
                }
              </span>
            </div>
          </div>
        )}
        <div className="booking-form__row pt-3">
          <div className="booking-form__label">
            <label className="form-label user-select-none">
              {/* [チェックボックス] */}
            </label>
          </div>
          <div className="booking-form__control d-flex align-items-center">
            <input
              checked={isCustomStayDuration}
              className="form-check-input"
              type="checkbox"
              onChange={handleChangeCustomStayDuration}
            />
            <span className=" user-select-none">
              「席だけ予約の滞在時間」より短い滞在時間での予約を許可
            </span>
          </div>
        </div>
        {/* <h2 className="text-center">{message}</h2> */}
        <div className="booking-form__btns">
          <MyButton className="me-1" myVariant="cancel" onClick={onClose}>
            いいえ
          </MyButton>
          <MyButton myVariant="accept" onClick={() => onAccept(stayDuration)}>
            はい
          </MyButton>
        </div>
      </div>
    </Dialog>
  );
};

export default React.memo(ConfirmModal);
